import script from "./PublicationName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationName.vue?vue&type=script&lang=js"
export * from "./PublicationName.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-pages/story-page/PublicationName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c2239f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c2239f4', __exports__)) {
    api.reload('5c2239f4', __exports__)
  }
  
}


export default __exports__